import DeleteProjectModal from './DeleteProjectModal';
import MaximumNumberOfProjectsModal from './MaximumNumberOfProjectsModal';
import UpdateProjectModal from './UpdateProjectModal';
import useProjects from '../../../hooks/providers/useProjects';
import useWorkspaces from '../../../hooks/providers/useWorkspaces';
import EmmaiMonthlyRestitutionModal from '../../emmai-forms/forms-components/forms/EmmaiMonthlyRestitutionModal/EmmaiMonthlyRestitutionModal';
import ManageWorkspaceOrReportUsersModal from '../../workspaces/users/ManageWorkspaceOrReportUsersModal';
import CreateDatalakeConnectionModal from '../create/CreateDatalakeConnectionModal';
import ManageProjectUsersModal from '../users/ManageProjectUsersModal';

const ConnectionsPageModals = () => {
  const {selectedProject} = useProjects();
  const {rightClickedWorkspace, rightClickedReportTab} = useWorkspaces();
  return (
    <>
      <CreateDatalakeConnectionModal />

      <MaximumNumberOfProjectsModal />

      {(rightClickedWorkspace || rightClickedReportTab) && <ManageWorkspaceOrReportUsersModal isWorkspaceUsersList={rightClickedWorkspace ?? false} />}

      {selectedProject && (
        <>
          <UpdateProjectModal />

          <ManageProjectUsersModal />

          <DeleteProjectModal />
        </>
      )}
    </>
  );
};

export default ConnectionsPageModals;
